import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ConfigurationManagementService } from '../../../service/configuration-management.service';
import { LanguageManagementService } from '../../../service/language-management.service';
import { ActiveInactiveFor, GeneralConfigType, KeyValues5, LocalService, PageKey, ReceiptType, Status, TriggeredEvent, Wrappers5 } from '../../../service/local.service';
import { GeneralConfigurationPopupComponent } from '../../popups/general-configuration-popup/general-configuration-popup.component';
import { ReceiptTemplateComponent } from '../../popups/receipt-template/receipt-template.component';

@Component({
  selector: 'app-general-configuration',
  templateUrl: './general-configuration.component.html',
  styleUrls: ['./general-configuration.component.scss']
})
export class GeneralConfigurationComponent implements OnInit {
  ReceiptType = ReceiptType; GeneralConfigType = GeneralConfigType;
  lstSectionConfigKeys: string[] = ["table"]; hasCtryCode: boolean = false;
  source: Wrappers5; ctryCodeSub: string = ''; businessId: string;
  configType: GeneralConfigType = GeneralConfigType.None; maxBodyHeight = 0;
  constructor(public localService: LocalService, private cdr: ChangeDetectorRef, private languageManagementService: LanguageManagementService, private modalService: NgbModal, private route: ActivatedRoute, private configurationManagementService: ConfigurationManagementService, private router: Router) { }

  ngOnInit(): void {
    this.languageManagementService.ensureLanguageSectionKeys(this.lstSectionConfigKeys);
    this.route.params.subscribe(routeParams => {
      this.configurationManagementService.ensurePageActions(PageKey.GeneralConfig);
      this.localService.saveUrl();
      this.businessId = routeParams.businessId;
      this.localService.setBasicParams(routeParams.ctryCode, routeParams.userId, routeParams.interactionType, this.businessId);
      this.hasCtryCode = routeParams.hasCtryCode == "1";
      this.ctryCodeSub = routeParams.ctryCodeSub != "0" ? routeParams.ctryCodeSub : '';
      this.configType = parseInt(routeParams.id);
      this.onLoad();
    });
  }

  ngAfterViewChecked() {
    this.maxBodyHeight = this.localService.onGetCustomBodyHeight();
    this.cdr.detectChanges();
  }

  isLoading = false;
  onLoad(isUpdate = false) {
    if (!this.isLoading) {
      this.isLoading = true;
      this.configurationManagementService.getConfigurations(this.configType, !this.source ? null : this.source.paging, this.hasCtryCode, isUpdate, this.ctryCodeSub, this.businessId).subscribe(result => {
        this.source = result;
        this.isLoading = false;
      });
    }
  }

  onActiveInactiveStatus(strId: string) {
    this.configurationManagementService.activeInactiveStatus(strId, ActiveInactiveFor.Configuration, this.businessId).subscribe(result => {
      this.localService.showInformationByStatus(result);
      if (result == Status.Success) {
        const updatedItem = this.source.items.find(x => x.key == strId);
        updatedItem.v2 = updatedItem.v2 == "1" ? "0" : "1";
      }
    });
  }

  openCreateEditPopup(id: string, ctryCodeSub = '') {
    if (!this.businessId) {
      if (!this.hasCtryCode) {
        const modalRef = this.modalService.open(GeneralConfigurationPopupComponent, { ariaLabelledBy: 'modal-basic-title' });
        modalRef.componentInstance.id = id;
        modalRef.componentInstance.ctryCode = this.ctryCodeSub;
        modalRef.componentInstance.configType = this.configType;
        modalRef.result.then((result) => {
          if (result.event == TriggeredEvent.Ok) {
            if (id == '') {
              let wrapper = {
                v3: result.wrapper.seleletedLanguageValue,
                key: result.wrapper.id,
                v1: this.configType.toString(),
                v2: "1"
              } as KeyValues5;
              this.source.items.push(wrapper);
            }
            else {
              const temp = this.source.items.find(x => x.key == result.wrapper.id);
              temp.v3 = result.wrapper.seleletedLanguageValue;
            }
          }
        });
      } else {
        this.oNavigate(ctryCodeSub, false, id)
      }
    }
  }

  onOpenReceiptTemplate(receiptType: string, isConfigurable: boolean) {
    const modalRef = this.modalService.open(ReceiptTemplateComponent, { size: 'lg' });
    modalRef.componentInstance.receiptType = parseInt(receiptType);
    modalRef.componentInstance.isConfigurable = isConfigurable;
    modalRef.componentInstance.businessId = this.businessId;
  }

  isDisableReceiptTemplate(receiptTypeKey: string): boolean {
    if (ReceiptType[parseInt(receiptTypeKey)] != undefined) {
      if (ReceiptType[parseInt(receiptTypeKey)].startsWith('Fix_Direct')) {
        return !(ReceiptType[parseInt(receiptTypeKey)].endsWith('Gen') || ReceiptType[parseInt(receiptTypeKey)].endsWith('XXmm'));
      }
    }
    return false;
  }

  onOpenSmsTemplate(key: string, communicationTemplateType: string) {
    this.router.navigate(['/template-ids' + this.localService.basicParamsString, key, this.configType, communicationTemplateType]);
  }

  oNavigate(ctryCodeSub: string, hasCtryCode, key) {
    this.router.navigate(['/general-configuration' + this.localService.basicParamsString, ctryCodeSub == '' ? '0' : ctryCodeSub.toLowerCase(), hasCtryCode ? '1' : '0', key]);
  }

  onAction(index: number, key?: string, key2?: string) {
    switch (index) {
      case 1: {
        if (ReceiptType[parseInt(key)].startsWith('Fix_Direct')) {
          this.router.navigate(['/receipt-html' + this.localService.basicParamsString, key, key2]);
        } else {
          this.router.navigate(['/receipt-options-html' + this.localService.basicParamsString, key, this.businessId ?? 0]);
        }
      } break;
      case 2: {
        this.router.navigate(['/general-configuration' + this.localService.basicParamsString, 0, 0, 0]);
      } break;
    }
  }

  onCloseReceiptOptionsHtml(result?: any) {

  }
}
